import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { useTheme } from 'lib/context/ThemeContext';

import classNames from 'classnames';
import Component from 'src/helpers/Component/Component';
import { ARProductCardTheme } from './ARProductCard.theme';
import CallToActionAR from 'src/helpers/CallToActionAR/CallToActionAR';
import ImageWrapper from 'src/helpers/Media/ImageWrapper';

export type ARProductCardProps = Feature.EnterpriseWeb.RenewalByAndersen.Cards.ARProductCard;

const ARProductCard = (props: ARProductCardProps): JSX.Element | null => {
  const { fields } = props;
  const { themeData } = useTheme(ARProductCardTheme);

  if (!fields || !fields.productImageThumbnail?.value?.src) {
    return null;
  }

  const { productName, productImageThumbnail } = fields;

  return (
    <Component dataComponent="card/arproductcard" variant="lg" {...props}>
      <div className={classNames(themeData.classes.cardWrapper)}>
        {productName?.value && (
          <h3 className={classNames(themeData.classes.headline)}>{productName?.value}</h3>
        )}
        <div className={classNames(themeData.classes.immageWrapper)}>
          <ImageWrapper
            image={productImageThumbnail}
            imageLayout="responsive"
            additionalDesktopClasses="max-w-full"
            additionalMobileClasses="max-w-full"
          ></ImageWrapper>
        </div>
        <CallToActionAR
          fields={{
            buttonText: fields?.buttonText,
            buttonIcon: fields?.buttonIcon,
            usdzLink: fields?.usdzLink,
            gltfLink: fields?.gltfLink,
            posterImage: fields?.posterImage,
            arShareSubjectTemplate: fields?.arShareSubjectTemplate,
            arShareMessageTemplate: fields?.arShareMessageTemplate,
            arDesktopMessage: fields?.arDesktopMessage,
          }}
          classes={{
            wrapper: classNames(themeData.classes.buttonWrapper),
            buttonClasses: classNames(themeData.classes.button),
            buttonIconClasses: classNames(themeData.classes.buttonIcon),
          }}
          name=""
          id=""
          url=""
        />
      </div>
    </Component>
  );
};

export default withDatasourceCheck()<ARProductCardProps>(ARProductCard);
